// Merchant capabilities arrive as a serialized array on the info payload, and gate whole
// interfaces - v2-checkout picks the checkout, cart-modals picks the product card. That payload is
// merchant data reaching the storefront's first render, so anything that is not a list holding the
// exact name reads as "not granted" rather than throwing.
export function hasCapability(info, name) {
  const capabilities = info?.attributes?.capabilities
  return Array.isArray(capabilities) && capabilities.includes(name)
}
